export interface NavMenuItem {
    label: string;
    icon: string;
    route?: string;
    roles?: string[];
    require_auth?: boolean;
}

export class Menu {
    getMainMenu() {
        return MainMenu;
    }
}

const MainMenu: NavMenuItem[] = [
    {
        label: 'home',
        icon: 'home',
        route: 'home'
    },
    {
        label: 'scores',
        icon: 'tournament',
        route: 'tournament'
    },
    {
        label: 'ranking',
        icon: 'ranking',
        route: 'ranking'
    },
    {
        label: 'news',
        icon: 'news',
        route: 'articles'
    }
    // {
    //     label: 'bracket',
    //     icon: 'sports_esports',
    //     route: 'bracket'
    // }
]
